"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RequestType;
(function (RequestType) {
    RequestType["SubscribeRealTimeData"] = "30bf4945-1eb5-4584-9d41-5721aaee64cf";
    RequestType["SubscribeRealTimeDataResponse"] = "e379edff-824c-4cb8-945f-b6f8f2c2b260";
    RequestType["GetDataAfterTime"] = "f0d9e43c-6131-41fe-ba70-138c6fd51393";
    RequestType["GetDataAfterTimeResponse"] = "7915b81f-465c-4970-9eef-e453ab3e7766";
})(RequestType = exports.RequestType || (exports.RequestType = {}));
;
//# sourceMappingURL=requestTypes.js.map


// WEBPACK FOOTER //
// ./src-client-lib/api/requestTypes.js